import * as React from 'react';
import {view, createView, type View} from '@sail/engine';

export const ToastButton = createView<View.IntrinsicElement<'button'>>(
  ({children, ...props}) => {
    return (
      <view.button {...props}>
        <view.span
          css={{
            stack: 'x',
            alignX: 'center',
            alignY: 'center',
            transform: 'translateY(var(--content-offset-y))',
          }}
        >
          {children}
        </view.span>
      </view.button>
    );
  },
  {
    css: {
      stack: 'x',
      alignX: 'center',
      alignY: 'center',
      border: 'none',
      outline: 'none',
      padding: 'medium',
      backgroundColor: 'transparent',
      transitionProperty: 'all',
      transitionDuration: 'xshort',
      transitionTimingFunction: 'standard',
      whiteSpace: 'nowrap',

      '--content-offset-y': '0px',

      ':focus-within': {
        focusRing: 'focus',
      },

      ':hover:not(:active)': {
        backgroundColor: 'translucent',
      },

      ':active:not([aria-disabled="true"])': {
        '--content-offset-y': '1px',
      },
    },
  },
);
